module.exports = __webpack_public_path__ + "img/icons-list-5.28d90593.png";